"use client";

import { TextField, useFormFields } from "@payloadcms/ui";
import { TextFieldClient, TextFieldClientProps } from "payload";
import { useMemo } from "react";

export function EmbedAdminBlock({ field, path, validate }: TextFieldClientProps) {
  const idField = useFormFields(([fields]) => fields["embedId"]);
  const sourceField = useFormFields(([fields]) => fields["source"]);
  const orientationField = useFormFields(([fields]) => fields["orientation"]);

  const source = sourceField?.value as string | undefined;
  const id = idField?.value as string | undefined;
  const orientation = orientationField?.value as string | undefined;

  const props: TextFieldClient = useMemo<TextFieldClient>(
    () => ({
      ...field,
      type: "text",
      admin: {
        ...field.admin,
        label: "Embed",
        autoComplete: false,
        placeholder: "placeholder",
        rtl: false,
      },
    }),
    [field]
  );

  return (
    <>
      <TextField field={props} path={path} validate={validate} />
      {id && source && (
        <EmbedBlock blockType={"embed"} embedId={id} source={source} orientation={orientation} />
      )}
    </>
  );
}

export type EmbedBlockProps = {
  blockType: "embed";
  embedId: string;
  source: string;
  orientation?: string;
};

type Props = EmbedBlockProps & {
  className?: string;
};

export const EmbedBlock: React.FC<Props> = ({
  className,
  embedId,
  source,
  orientation = "portrait",
}: Props) => {
  function computeUrl(source: string, id: string) {
    if (source === "youtube") {
      return `https://www.youtube-nocookie.com/embed/${id}`;
    }

    if (source === "tiktok") {
      return `https://www.tiktok.com/embed/v2/${id}`;
    }

    if (source === "instagram") {
      return `https://www.instagram.com/p/${id}/embed/`;
    }

    return undefined;
  }

  const style =
    orientation === "portrait" ? { height: 721, maxWidth: "440px" } : { aspectRatio: "16/9" };

  return (
    <iframe
      className={className}
      src={computeUrl(source, embedId)}
      style={{
        margin: "auto",
        borderRadius: "12px",
        width: "100%",
        ...style,
      }}
    ></iframe>
  );
};
